import * as caseDataCollectTypes from './caseDataCollectTypes';
import { fetchQuestionnaireDataCollectPage, fetchQuestionnaireCard, getQuestionnaireProfileById } from 'src/services/questionnaire.service';
import { deriveMenuAndIndex } from './caseDataCollectReselect';

export const setCaseDetail = (payload, isReloaded = false) => {
  return {
    type: caseDataCollectTypes.SET_CASE_DETAIL_SUCCESS,
    payload,
    isReloaded,
  };
};
export const setReloadOnToggleChange = payload => {
  return {
    type: caseDataCollectTypes.SET_RELOAD_ON_TOGGLE,
    payload,
  };
};
export const setRefreshPageStatus = payload => {
  return {
    type: caseDataCollectTypes.SET_REFRESH_ON_PAGE,
    payload,
  };
};
export const setCaseSubmitted = payload => {
  return {
    type: caseDataCollectTypes.SET_CASE_SUBMIT_SUCCESS,
    payload,
  };
};

export const setQuestionnaireCard = payload => ({
  type: caseDataCollectTypes.SET_QUESTIONNAIRE_CARD,
  payload,
});

export const setQuestionnairePage = payload => ({
  type: caseDataCollectTypes.SET_QUESTIONNAIRE_PAGE,
  payload,
});

export const setQuestionnaireMenu = payload => ({
  type: caseDataCollectTypes.SET_QUESTIONNAIRE_MENU,
  payload,
});

export const resetReloadFlag = () => ({
  type: caseDataCollectTypes.RESET_IS_RELOADED,
});
export const resetQuestionnaire = () => ({
  type: caseDataCollectTypes.RESET_QUESTIONNAIRE,
});

export const refreshMenus = payload => ({
  type: caseDataCollectTypes.REFRESH_MENUS,
  payload,
});

export const setMenuIndex = payload => ({
  type: caseDataCollectTypes.SET_MENU_INDEX,
  payload,
});

export const setShowProfileIconNameState = payload => ({
  type: caseDataCollectTypes.SET_SHOW_PROFILE_ICONNAME_STATE,
  payload,
});

export const getQuestionnaireProfileSuccessful = payload => ({
  type: caseDataCollectTypes.GET_QUESTIONNAIRE_PROFILE_SUCCESS,
  payload,
});

export const updateMenuIndex = menuIndex => {
  return async dispatch => {
    dispatch(setMenuIndex({ menuIndex }));
  };
};

export const getQuestionnaireProfile = questionnaireId => {
  return async dispatch => {
    await getQuestionnaireProfileById(questionnaireId)
      .then(res => {
        if (res) {
          dispatch(getQuestionnaireProfileSuccessful(res));
        } else {
          throw new Error('failed to query questionnaire related profile');
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const getQuestionnaireCard = (languageId, caseManagerId) => {
  return async dispatch => {
    dispatch({ type: caseDataCollectTypes.GET_QUESTIONNAIRE_CARD });
    const response = await fetchQuestionnaireCard({ languageId, caseManagerId });
    if (response && response.success) {
      return dispatch(setQuestionnaireCard(response.messages));
    }
    if (response && response.error && response.error.code === 404) {
      return dispatch(setQuestionnaireCard({ isEmpty: true }));
    }
    if (!response || (response && response.success === false)) {
      return dispatch(setQuestionnaireCard({ isError: true }));
    }
  };
};

export const getQuestionnairePage = (body, mock) => {
  return async (dispatch, getState) => {
    dispatch({ type: caseDataCollectTypes.GET_QUESTIONNAIRE_PAGE });
    const response = mock ? await import('./manualFixShowOrganizerResponse.json') : await fetchQuestionnaireDataCollectPage(body);
    if (response && response.success) {
      dispatch(setQuestionnairePage(response));
      const newMenu = deriveMenuAndIndex(body.pageId, false)(getState());
      dispatch(setQuestionnaireMenu(newMenu));
    } else {
      if (response.error) throw Error(response.error.message);
    }
  };
};

export const updateMenu = (menus, body) => {
  return async (dispatch, getState) => {
    dispatch(refreshMenus(menus));
    const newMenu = deriveMenuAndIndex(parseInt(body.pageId, 10), body.complete || false)(getState());
    dispatch(setQuestionnaireMenu(newMenu));
  };
};

export const toggleSpinner = isLoading => ({
  type: caseDataCollectTypes.SET_SPINNER_STATUS,
  isLoading,
});

export const updatePageData = pageData => {
  return dispatch => {
    dispatch({
      type: caseDataCollectTypes.SET_PAGE_DATA,
      pageData,
    });
  };
};

export const setDocumentTaskStatusState = payload => ({
  type: caseDataCollectTypes.SET_TASK_DOCUMENT_DISABLED_STATUS,
  payload,
});

export const setCaseDataHeader = payload => {
  return {
    type: caseDataCollectTypes.SET_CASE_HEADER_DETAIL_SUCCESS,
    payload,
  };
};
